import React from 'react';

import {
  DetailsRowLabelStyled,
  DetailsRowStyled,
  DetailsRowValueStyled,
} from './DetailsRow.styled';

export const DetailsRowView = ({ children }: any) => (
  <DetailsRowStyled>{children}</DetailsRowStyled>
);

DetailsRowView.Label = DetailsRowLabelStyled;
DetailsRowView.Value = DetailsRowValueStyled;
